import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type {
  GetEvaluariDupaCuiResponse,
  GetNotificariRecalculResponse,
  MarcheazaNotificareCititaRequest,
  MarcheazaNotificareCititaResponse,
} from "@/api/types/notificari";

export async function getNotificariRecalcul(): Promise<GetNotificariRecalculResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/notificari-recalcul",
    { method: "GET" }
  );
  await handleSupabaseFunctionError(error);
  if (!data) throw new Error("Răspuns invalid de la notificari-recalcul");
  return data;
}

export async function marcheazaNotificareCitita({
  id,
  recalculat = false,
}: MarcheazaNotificareCititaRequest): Promise<MarcheazaNotificareCititaResponse> {
  const { data, error } = await supabase.functions.invoke(
    `api/notificari-recalcul/${id}/citita?recalculat=${recalculat}`,
    { method: "POST" }
  );
  await handleSupabaseFunctionError(error);
  if (!data)
    throw new Error("Răspuns invalid de la notificari-recalcul/citita");
  return data;
}

export async function getEvaluariDupaCui(
  cui: string
): Promise<GetEvaluariDupaCuiResponse> {
  const { data, error } = await supabase.functions.invoke(
    `api/evaluari/${encodeURIComponent(cui)}`,
    { method: "GET" }
  );
  await handleSupabaseFunctionError(error);
  if (!data) throw new Error("Răspuns invalid de la evaluari");
  return data;
}
